import React, { useState, useEffect, useRef } from "react";
import "./ChatPage.css";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import profile from "../../assets/svg/Face1.svg";
import searchIcon from "../../assets/svg/Search1.svg";
import cha from "../../assets/svg/Cha1.svg";
import Nav from "../../assets/svg/icon1.svg";
import right from "../../assets/svg/right1.svg";
import maiLogo from "../../assets/svg/chat-bot/Logo.svg";
import setting from "../../assets/svg/chat-bot/setting.svg";
import enter from "../../assets/svg/chat-bot/enter-msg.svg";
import micImgUrl from "../../assets/svg/chat-bot/Mic.svg";
import speechStop from "../../assets/svg/chat-bot/audio-stop.svg";
import lenteraLogo from "../../assets/png/lentera-logo.png";
import { useNavigate } from "react-router-dom";
import { header } from "../../services/getcookie";
import ChatGPTTypingEffect from "../../ChatGPTTyping";
import dropwDownArrow from "../../assets/svg/dropdown-arrow.svg";
import CustomSelect from "../../components/CustomSelect";
import CustomDropDownSelect from "../../components/CustomDropDown";
import { apiRequest } from "../../services/api_services/ApiServices";
import mawalogLogo from "../../assets/svg/mawalog.svg";
import { toast } from "react-toastify";
import AppBar from "../../components/AppBar";

const ChatPagePreDef = () => {
  const navigate = useNavigate();

  useEffect(() => {
    applicationList();

    const savedConvoId = localStorage.getItem("conversationId");

    if (savedConvoId) {
      setConversationId(Number(savedConvoId));
      getChat(Number(savedConvoId));
    } else {
      getChat(0);
    }
  }, []);

  const handleChange = (event) => {
    setInputField(event.target.value);
  };

  const apiUrl = process.env.REACT_APP_API_URL;
  const endRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [answerLoading, setAnswerLoading] = useState(false);
  const [convoList, setConvoList] = useState([]);
  const [id, setChatId] = useState(0);
  const [modelSelect, setModelSelect] = useState("");
  const recognitionRef = useRef(null);
  const [inputField, setInputField] = useState("");
  const [isListening, setIsListening] = useState(false);
  const [isNewAnswer, setIsNewAnswer] = useState(false);
  const [conversationId, setConversationId] = useState(-1);
  const [newChat, setNewChat] = useState("");
  const [inputMessage, setInputMessage] = useState("");
  const [options, setOptions] = useState([]);
  const [application, setApplication] = useState("");

  const modelOptions = [
    { value: "pre_defined", label: "Pre defined model" },
    { value: "application", label: "Application model" },
  ];

  const [showNewChat, setShowNewChat] = useState(true);
  let recognition = null;

  const [chatConversation, setChatConversation] = useState([
    { welcome: "welcome" },
  ]);

  const initializeRecognition = () => {
    if (!("webkitSpeechRecognition" in window)) {
      alert("Your browser does not support Speech Recognition.");
      return null;
    }

    const recognitionInstance = new window.webkitSpeechRecognition();
    recognitionInstance.continuous = true;
    recognitionInstance.interimResults = true;
    recognitionInstance.lang = "en-US";

    recognitionInstance.onresult = (event) => {
      const transcript = Array.from(event.results)
        .map((result) => result[0].transcript)
        .join("");

      console.log("transcript");
      console.log(transcript);
      setInputField(transcript);
    };

    recognitionInstance.onend = () => {
      setIsListening(false);
    };

    return recognitionInstance;
  };

  const startListening = () => {
    setIsListening(true);
    if (!recognitionRef.current) {
      recognitionRef.current = initializeRecognition();
    }
    if (recognitionRef.current) {
      recognitionRef.current.start();
    }
  };

  const stopListening = () => {
    if (recognitionRef.current) {
      recognitionRef.current.onend = null;
      recognitionRef.current.stop();
      console.log("Stopped manually");
    }
    setIsListening(false);
  };

  const applicationList = async () => {
    try {
      const response = await apiRequest({
        method: "GET",
        url: "app_list",
      });

      if (response.statusCode == 400) {
      } else {
        if (response?.success) {
          const applications = response.data?.data ?? [];

          const formattedOptions = applications.map((app) => ({
            value: app.id,
            label: app.name,
            icon: app.icon,
          }));
          getConversation(applications);
          setOptions(formattedOptions);

          if (formattedOptions.length > 0) {
            setApplication(formattedOptions[0].value);
            getConversation(formattedOptions[0].value);
          }
        } else {
          console.error(response?.message || "Failed to fetch applications");
        }
      }
    } catch (error) {
      console.error("Application list error:", error);
    }
  };

  const handleSubmitQuestion = () => {
    if (modelSelect === "selective model") {
      toast.warning("Please select model to chat!");
    } else {
      console.log("inputField");
      console.log(inputField);

      if (inputField !== "") {
        const tempConversation1 = [...chatConversation];
        const txt = inputField;

        console.log("txt");
        console.log(txt);

        tempConversation1.push({ question: txt, dateAt: new Date() });
        setChatConversation(tempConversation1);
        console.log(tempConversation1);
        setInputField("");

        console.log("txt");
        console.log(txt);

        console.log("tempConversation1");
        console.log(tempConversation1);

        sendMessage(txt, tempConversation1);
        setTimeout(() => {
          endRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 500);
      }
    }
  };

  const sendMessage = async (question, tempConversation) => {
    try {
      const response = await apiRequest({
        method: "Post",
        url: "prechat",
        data: {
          message: question,
          app_id: String(application),

          convo_id: conversationId ? String(conversationId) : "",
        },
      });
      if (response.statusCode === 400) {
      } else {
        console.log("save-response");
        console.log(response.success);
        if (response.success === true) {
          setConversationId(response.id);
          setIsNewAnswer(true);
          console.log("before answer", chatConversation);

          tempConversation.push({ answer: response.answer });
          console.log("after answer", tempConversation);
          setChatConversation(tempConversation);
          getConversation(application);
          setNewChat("Add Convon Id");
          setTimeout(() => {
            endRef.current?.scrollIntoView({ behavior: "smooth" });
          }, 500);
        }
      }
    } catch (e) {}
  };

  const submitQuestion = async (question, tempConversation) => {
    setLoading(true);
    setAnswerLoading(true);

    try {
      if (
        conversationId === null ||
        conversationId === undefined ||
        conversationId === -1
      ) {
        const response = await axios
          .post(
            apiUrl + `prechat/` + conversationId,
            {
              query: question,
              application: application,
            },
            {
              headers: header(),
            },
          )
          .then((response) => {
            if (response.statusCode === 400) {
            } else {
              console.log("save-response");
              console.log(response);
              if (response.data.success === true) {
                setConversationId(response.data.id);
                setIsNewAnswer(true);
                console.log("before answer", chatConversation);

                tempConversation.push({ answer: response.data.answer });
                console.log("after answer", tempConversation);
                setChatConversation(tempConversation);
                setTimeout(() => {
                  endRef.current?.scrollIntoView({ behavior: "smooth" });
                }, 500);
              }
            }
          })
          .catch((error) => {
            if (error.response) {
              console.error("Error Status:", error.response.status);
              console.error("Error Data:", error.response.data);
              if (error.response.status === 400) {
              }
            } else {
              console.error("Request failed:", error.message);
            }
          });
      } else {
        await axios
          .put(
            apiUrl + `conversation/` + conversationId,
            {
              query: question,
              application: application,
            },
            {
              headers: header(),
            },
          )
          .then((response) => {
            if (response.statusCode === 400) {
            } else {
              if (response.data.success === true) {
                setConversationId(response.data.id);
                setIsNewAnswer(true);
                console.log("before answer", chatConversation);

                tempConversation.push({ answer: response.data.answer });
                console.log("after answer", tempConversation);
                setChatConversation(tempConversation);
                setTimeout(() => {
                  endRef.current?.scrollIntoView({ behavior: "smooth" });
                }, 500);
              }
            }
          })
          .catch((error) => {
            if (error.response) {
              console.error("Error Status:", error.response.status);
              console.error("Error Data:", error.response.data);
              if (error.response.status === 400) {
              }
            } else {
              console.error("Request failed:", error.message);
            }
          });
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setAnswerLoading(false);
      setLoading(false);
    }
  };

  const getConversation = async (applicationId) => {
    try {
      const response = await axios
        .get(
          apiUrl +
            "/conversation?app_id=" +
            applicationId +
            "&search=&limit=100&skip=0",
          {
            headers: header(),
          },
        )
        .then(async (response) => {
          if (response.data.success === true) {
            setConvoList(response.data.convos);
            console.log("Hello", response.data);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Data:", error.response.data);
            if (error.response.status === 400) {
            }
          }
        });
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getChat = async (id) => {
    console.log("📥 getChat called with id:", id);

    setChatId(id);

    if (id === 0) {
      console.log("🆕 New chat selected, clearing conversation");
      setChatConversation([]);
      return;
    }

    setIsNewAnswer(false);

    try {
      console.log(
        "🌐 Fetching conversation API:",
        apiUrl + "conversation/" + id,
      );

      const response = await axios.get(
        apiUrl + "conversation/" + id + "?app_id=" + application,
        {
          headers: header(),
        },
      );

      console.log("✅ API response:", response);

      if (response.data?.success === true) {
        console.log("💬 Chats received:", response.data.convo?.chats);

        setChatConversation(response.data.convo.chats);
      } else {
        console.warn("⚠️ API success is false:", response.data);
      }
    } catch (error) {
      console.error("❌ API error occurred");

      if (error.response) {
        console.error("🔴 Status:", error.response.status);
        console.error("🔴 Data:", error.response.data);

        if (error.response.status === 400) {
          console.warn("⚠️ Bad request (400)");
        }
      } else {
        console.error("❌ Network / unknown error:", error);
      }
    } finally {
      console.log("🔚 getChat API call finished");
    }
  };

  return (
    <div className="chat-container">
      <div className="sidebar" style={{ backgroundColor: "#F5F5F5" }}>
        <div className="f-header flex justify-between">
          <img
            src={maiLogo}
            alt="Logo"
            className="logo"
            style={{ width: "92.05px", height: "32px" }}
          />

          <img
            src={setting}
            alt="Settings"
            onClick={() => navigate("/admin_setting")}
            style={{ width: "25px" }}
          />
        </div>

        <div className="conversation-section">
          <div className="conversation-header flex items-center justify-between ">
            <h3 className="conversation-title mt-2 font-omny text-lg">
              Conversations
            </h3>
            <div className=""></div>
          </div>

          <div
            style={{
              overflowY: "scroll",
              overflowX: "hidden",
              height: "100%",
              marginTop: "24px",
            }}
          >
            <div
              className="conversation-container"
              style={{
                height: "400px",
                gap: "8px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {convoList.length > 0 ? (
                convoList.map((convo, index) => (
                  <div
                    key={index}
                    className="conversation-item"
                    style={{
                      width: "240px",
                      fontSize: "14px",
                      borderRadius: "24px",
                      padding: "15px",
                      gap: "1px",
                      backgroundColor: "white",
                      color: "black",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                    onClick={() => {
                      setConversationId(convo.id);
                      localStorage.setItem("conversationId", convo.id);
                      getChat(convo.id);
                    }}
                  >
                    <img
                      src={cha}
                      alt="Chat"
                      className="conversation-icon"
                      style={{
                        width: "20px",
                        height: "20px",
                        borderRadius: "10px",
                        gap: "10px",
                      }}
                    />
                    <span>{convo.title}</span>{" "}
                  </div>
                ))
              ) : (
                <p>No conversations found</p>
              )}
              <div>
                <button
                  className="new-chat-btn"
                  style={{
                    width: "122px",
                    height: "44px",
                    borderRadius: "100px",
                    padding: "7px 16px",
                    backgroundColor: "#007bff",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "fixed",
                    bottom: "2%",
                    left: "10%",
                  }}
                  onClick={() => {
                    if (modelSelect === "selective model") {
                      toast.warning("Please select model to chat!");
                    } else {
                      getChat(0);
                      setNewChat("");
                      getConversation(application);
                    }
                  }}
                >
                  + New chat
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="chat-window"
        style={{
          backgroundColor: "#FFFFFF",
          width: "100%",
          overflowY: "hidden",
        }}
      >
        <div className="d-flex flex-column vh-100">
          <div className="d-flex flex-column">
            {/* <div className="d-flex justify-content-between">
              <div>
                <img src={right} style={{ width: "40px", height: "40px" }} />
              </div>
              <div>
                <img src={profile} style={{ width: "40px", height: "40px" }} />
              </div>
            </div> */}
            <AppBar classNameAppBar="h-[40px] bg-white " />

            {/* <AppBar right={right} profile={profile}/> */}
          </div>

          <div style={{ overflowY: "auto", maxHeight: "70vh" }}>
            {chatConversation.length > 0 ? (
              chatConversation.map((chat, index) => {
                return (
                  <div
                    key={"chat" + index}
                    style={{ width: "100%", marginTop: "10px" }}
                  >
                    <div
                      className="text-center"
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        color: "#66737E",
                      }}
                    >
                      {chat.date}
                    </div>

                    {chat.question && (
                      <div
                        className="d-flex justify-content-end"
                        style={{
                          gap: "8px",
                          marginBottom: "20px",
                        }}
                      >
                        <div>
                          <div
                            style={{
                              borderRadius: "20px 20px 20px 4px",
                              backgroundColor: "#EAF4FF",
                              padding: "10px 12px 10px 12px",
                              fontWeight: "400",
                              color: "091E42",
                              fontSize: "14px",
                              maxWidth: "fit-content",
                              marginBottom: "10px",
                            }}
                          >
                            {chat.question}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "end",
                              gap: "6px",
                              fontWeight: "400",
                              fontSize: "12px",

                              color: "#98A180",
                            }}
                          >
                            {chat.date}{" "}
                            <span
                              style={{
                                fontWeight: "400",
                                fontSize: "12px",
                                color: "#98A180",
                              }}
                            >
                              .
                            </span>{" "}
                            <span
                              style={{
                                fontWeight: "700",
                                fontSize: "11px",
                                color: "#0066CC",
                              }}
                            >
                              You
                            </span>
                          </div>
                        </div>
                      </div>
                    )}

                    {chat.answer && (
                      <div
                        className="d-flex"
                        style={{ gap: "8px", marginBottom: "20px" }}
                      >
                        <div>
                          <img
                            src={Nav}
                            style={{ width: "32px", height: "32px" }}
                          />
                        </div>

                        <div>
                          <div
                            style={{
                              borderRadius: "20px 20px 20px 4px",
                              backgroundColor: "#F2F2F2",
                              padding: "10px 12px 10px 12px",
                              fontWeight: "400",
                              color: "091E42",
                              fontSize: "14px",
                              marginBottom: "10px",
                            }}
                          >
                            {(chatConversation.length - 1 !== index ||
                              !isNewAnswer) &&
                              chat.answer}
                            {chatConversation.length - 1 === index &&
                              isNewAnswer && (
                                <ChatGPTTypingEffect text={chat.answer} />
                              )}
                          </div>
                          <div
                            style={{
                              fontWeight: "400",
                              fontSize: "12px",
                              color: "#98A180",
                            }}
                          >
                            {chat.date}
                          </div>
                        </div>
                      </div>
                    )}
                    <div ref={endRef} />
                  </div>
                );
              })
            ) : (
              <div
                className="d-flex"
                style={{ gap: "8px", marginBottom: "20px", marginTop: "20px" }}
              >
                <div>
                  <img src={Nav} style={{ width: "32px", height: "32px" }} />
                </div>

                <div>
                  <div>
                    <div
                      style={{
                        borderRadius: "20px 20px 20px 4px",
                        backgroundColor: "#F2F2F2",
                        padding: "10px 12px 10px 12px",
                        fontWeight: "400",
                        color: "#091E42",
                        fontSize: "14px",
                        width: "fit-content",
                        marginBottom: "10px",
                      }}
                    >
                      Welcome to our messaging page! Messaging let you improve
                      engagement with {modelSelect}.
                    </div>
                    <div
                      style={{
                        borderRadius: "20px 20px 20px 4px",
                        backgroundColor: "#F2F2F2",
                        padding: "10px 12px 10px 12px",
                        fontWeight: "400",
                        color: "#091E42",
                        fontSize: "14px",
                        width: "fit-content",
                      }}
                    >
                      Ask what you want?
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div ref={endRef} />
          </div>
        </div>
        <div className="d-flex flex-column" style={{ gap: "12px" }}>
          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
            }}
          >
            <div className="relative w-full">
              <input
                placeholder="Enter your message"
                type="text"
                className="w-full px-4 py-3 pr-14"
                style={{
                  borderRadius: "24px",
                  backgroundColor: "#F5F5F5",
                  border: "none",
                  outline: "none",
                }}
                value={inputField}
                onChange={handleChange}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSubmitQuestion();
                  }
                }}
              />
              <CustomDropDownSelect
                containerStyle="
    absolute right-20 top-7 -translate-y-1/2
    text-sm
    cursor-pointer
    rounded-md
    flex 
    p-2
  "
                options={options}
                value={application}
                onChange={(value) => {
                  if (value === application) {
                    return;
                  }

                  setApplication(value);

                  setConversationId(null);
                  localStorage.removeItem("conversationId");
                  setChatConversation([]);

                  getConversation(value);
                }}
              />

              <img
                src={enter}
                onClick={handleSubmitQuestion}
                className="absolute right-3 top-7 -translate-y-1/2 cursor-pointer"
                width="34"
                height="34"
                alt="send"
              />
            </div>
          </div>
          <div className="text-xs justify-center text-[#8790A1] flex font-omny gap-1">
            Powered by{" "}
            <span className="text-sm justify-center text-[#8790A1] flex font-omny gap-2">
              <img
                src={mawalogLogo}
                alt="logo"
                className="cursor-pointer"
                onClick={() => window.open("https://mawalog.com/", "_blank")}
              ></img>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatPagePreDef;
